<template>
    <v-main >
        <v-layout  justify-space-between>
            
            <v-flex lg6 xs12 v-show="!swipeDirection"  >

                   <v-card class="elevation-0 scroll-right px-lg-10 py-lg-5 px-2 py-5" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}">
                    
                       <span class="font-weight-black text-lg-body-1 text-body-2">
                         Attendance Issues
                       </span>

                        <monthlyReport v-on:addNewTrigger="NewData($event)" v-on:getDataForm="EditForm($event)" :report="report"/>
                    
                   </v-card>
                         
            </v-flex>



            
            <v-flex lg6 xs12 px-lg-10 px-5 mt-lg-n1  d-lg-flex v-show="swipeDirection" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}" class="boxbg scroll-left scrollUp " >
                      <div class="mt-5"> 
                            

                            <ReviewForm v-if="addnew" :bus="bus" :attendance-data="attendanceData" v-on:updateRecord="updateFormRecord($event)" ref="weeklyReport"/>
                            <div v-if="!addnew" class="mt-16 ml-12 text-lg-h6">

                                <p> Click Add New to Entry a Data or Select Existing Data to Update </p>

                            </div>

                      </div>
            </v-flex>
            
     </v-layout>
    </v-main>
</template>

<script >
import Vue from 'vue'
import monthlyReport from '@/components/MonitoringRating/Performance/attendanceIssue/attendanceReport'
import ReviewForm from '@/components/MonitoringRating/Performance/attendanceIssue/attendanceForm'

export default {
    name: 'complaintsForm',
    components:{
     monthlyReport,
     ReviewForm
    },
    data: () => {
        return {
           bus: new Vue(),
           report: new Vue(),
           addnew:false,
           attendanceData:'',
           
           
        }
    },
    methods:{

        NewData(value){

            this.addnew =  value
            this.bus.$emit('insertNewItem')
            
        },
        EditForm(value){

            this.bus.$emit('sendDataAttendance')
            this.addnew = true
            this.attendanceData = value
            

        },
        updateFormRecord(val){
            Vue.prototype.$backData = val
            this.report.$emit('updateNewData')
        }

    },
    
}

</script>
<style scoped>

</style>
<style scoped>

.boxbg {
    background-color:#F6F6F6 !important;
}
.monsterrat{
   font-family: 'Montserrat', serif !important;
}
html {
    font-family: 'Montserrat', serif !important;
    overflow-y: hidden !important;
}
.input-size{
    max-width: 142px !important;
}
.select-input{
    max-width: 142px !important;
}
.header{
    background-color:#E5E5E5;
    
}
.criteria{
    background-color: white !important;
}
@media only screen and (max-width: 1200px) {
.input-size{
            max-width: 100% !important;
}
.select-input{
    max-width: 82% !important;
}
.header{
    width: 100% !important;
    
}
}
</style>